import {take} from 'rxjs/operators';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';
import {TranslationHandlerService} from "@ispm/core/services/translation-handler.service";

const GENERIC_ERROR_TITLE = 'genericError.';

@Component({
  selector: 'gen-generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss']
})
export class GenericErrorComponent implements OnInit {
  public errorType: string;
  public errorMessage: string;

  constructor(
    private translationHandlerService: TranslationHandlerService,
    private routerManagerService: RouterManagerService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.errorType = this.routerManagerService.queryParameters.errorType;
    if (this.errorType) {
      this.translationHandlerService.queryDictionary(navigator.language || 'en-US')
        .pipe(take(1))
        .subscribe((data) => {
        let key = `${GENERIC_ERROR_TITLE + this.errorType.toString()}`;
        this.errorMessage = data.body.response.content[key];
          this.errorMessage && this.cdr.detectChanges();
      });
    }
  }
}
